// eslint-disable-next-line import/no-anonymous-default-export
export default
{
    cusCity: 'CITY',
    cusRegion: 'STATE',
    cusStreet: 'STREET',
    cusPostalCode: 'ZIP',
    cusFriendlyName: 'NAME',
};
